<!-- ログインボタン -->
<template>
  <a class="crly-a-common-btn-sign-up crly-icon" @click="clickLoginBtn">
    <div class="crly-a-common-btn-sign-up__icon crly-icon"></div>
    <span class="crly-a-common-btn-sign-up__label crly-icon-txt"></span>
  </a>
</template>

<script>
import API_PATH from "@crly/repositories/apiPath.js";
import { createSetCookie } from "@/utils/cookie";

export default {
  name: "CrlyAtomsCommonBtnLogin",
  methods: {
    clickLoginBtn() {
      document.cookie = createSetCookie("back_uri", this.$route.fullPath);
      window.open(
        process.env.VUE_APP_API_URL +
          API_PATH.getSoftBankLoginPath +
          "?back_uri=" +
          process.env.VUE_APP_BASE_URL +
          this.$route.fullPath,
        "_self"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@crly/assets/css/atoms/common/btn/login.scss";
</style>
